<script setup>
defineProps(["class"]);
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M21 9H15V3"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="miter"
        />
        <path
            d="M3 15H9V21"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
            stroke-linejoin="miter"
        />
        <path
            d="M15 9L21 3"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
        />
        <path
            d="M9 15L3 21"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="square"
        />
    </svg>
</template>
